var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('p',{staticClass:"indent"},[_vm._v("天宏达安医药科技有限公司是一家面向全球，服务于新药及仿制药研发和生产的CDMO一站式综合服务商。公司恪守最高质量标准，凭借高度的专业性，优良的服务记录和丰富的项目管理经验，获得业界广泛认可。可满足国内外客户在药物研究各个阶段的不同需求，为客户提供原料药一体化整套的研发和生产服务，构建起创新药及仿制药一体化服务生态圈。")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0727ad8","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/service/cdmo.vue
// module id = null
// module chunks = 